<template>
  <div class="latest_music">
    <h1 v-if="showHeading">Latest Music</h1>

    <div id="custom_Scrollbar" v-if="youtubeMusics.length && this.$store.getters.jPlayer">
      <div class="music_list">
        <div class="music_detail" v-for="(youtubeMusic, index) in youtubeMusics" :key="youtubeMusic.id">
          <div class="music_play">
            <a href="javascript:void(0)" @click="playMusic(index)">
              <div v-if="0 && $store.getters.jPlayer.isPlaying && $store.getters.jPlayer.current === index" class="pause_btn">
                <i class="fas fa-pause" aria-hidden="true"></i>
              </div>
              <!-- <img v-else src="@/assets/images/play_btn.svg" alt="play_btn.svg"> -->
              <div v-else class="play-icon small">
                <i class="fa fa-play" aria-hidden="true"></i>
              </div>
            </a>
            <div class="music_title">
              <h6 class="capitalize">
                {{youtubeMusic.title}}
              </h6>
              <p>
                {{youtubeMusic.artist}}
              </p>
            </div>
          </div>
          <div class="music_time">
            <p>{{youtubeMusic.duration}}</p>
            <a target="_blank" class="music_link" :href="youtubeMusic.link">
              <i class="fas fa-external-link-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <main-loader></main-loader>
    </div>

  </div>
</template>

<script>
import YoutubeMusic from '@/models/YoutubeMusic'
export default {
  name: 'LatestMusic',
  props: ['showHeading'],
  data () {
    return {
      youtubeMusics: []
    }
  },
  mounted () {
    this.fetchYoutubeMusics()
  },
  methods: {
    fetchYoutubeMusics () {
      this.$store
        .dispatch('fetchYoutubeMusics')
        .then((resp) => {
          this.youtubeMusics = []
          resp.data.youtubeMusics.forEach(music => {
            this.youtubeMusics.push(new YoutubeMusic(music))
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    playMusic (index) {
      if (this.$store.getters.jPlayer.isPlaying && this.$store.getters.jPlayer.current === index) {
        this.$store.getters.jPlayer.pause()
      } else {
        this.$store.getters.jPlayer.play(index)
      }
      this.$store.getters.jPlayer.current = index
      console.log(this.$store.getters.jPlayer.isPlaying, this.$store.getters.jPlayer.current, index)
    }
  }
}

</script>

<style scoped>
.pause_btn {
  background: #a12c2d;
  color: white;
  width: 36px;
  border-radius: 50%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: .5rem;
}
.pause_btn .fas {
  font-size: 10px;
}
.main-loader {
  height: 80%;
  margin-left: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/LatestMusic.vue